<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<ul class="nav navbar-nav navbar-right" ng-app="">
    <li>
        <a
            [routerLink]="['/app/login']"
            *ngIf="!authenticated()"
            data-toggle="collapse"
            data-target=".navbar-collapse.in"
            >Login</a
        >
    </li>

    <li class="dropdown" ngbDropdown *ngIf="authenticated()">
        <a
            id="profilemenu"
            class="uib-dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            ngbDropdownToggle
        >
            <i class="glyphicon glyphicon-user"></i>
            <span>
                <span>{{ greeting() }}{{ subjectDisplayName() }}</span>
                <span class="caret"></span>
            </span>
        </a>

        <ul class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="profilemenu">
            <li role="menuitem" ngbDropdownItem>
                <a [routerLink]="['/app/profile']" data-toggle="collapse" data-target=".navbar-collapse.in">Profile</a>
            </li>
            <li role="menuitem" ngbDropdownItem>
                <a [routerLink]="['/app/datamanager']" data-toggle="collapse" data-target=".navbar-collapse.in"
                    >Data Manager</a
                >
            </li>
            <!--      <li role="menuitem" ngbDropdownItem>-->
            <!--        <a [routerLink]="['/app/datastatus']"-->
            <!--           data-toggle="collapse"-->
            <!--           data-target=".navbar-collapse.in">Data Status</a>-->
            <!--      </li>-->

            <li role="presentation" class="divider"></li>

            <li role="menuitem" ngbDropdownItem>
                <a
                    [href]="['/ext/WEB3D-Specification.pdf']"
                    target="_blank"
                    data-toggle="collapse"
                    data-target=".navbar-collapse.in"
                    >Documentation</a
                >
            </li>

            <li role="menuitem" ngbDropdownItem>
                <a
                    [href]="['/ext/WEB3D-FeatureHintLanguageTutorial.pdf']"
                    target="_blank"
                    data-toggle="collapse"
                    data-target=".navbar-collapse.in"
                    >Tutorial</a
                >
            </li>

            <li role="presentation" class="divider"></li>

            <li role="presentation" ngbDropdownItem>
                <a
                    role="menuitem"
                    tabindex="-1"
                    ui-sref-opts="{reload:true}"
                    [routerLink]="['/app/login']"
                    data-toggle="collapse"
                    data-target=".navbar-collapse.in"
                    (click)="logout()"
                    >Logout</a
                >
            </li>
        </ul>
    </li>
</ul>
